import moment from "moment";
import { getNegativeId } from "./GetNegativeId";
import { TimekeeperService } from "services/TimekeeperService";
import { ScheduleService } from "services/ScheduleService";
import { TotalizarService } from "services/TotalizarService";

const tk = new TimekeeperService()

const createPunch = async (setLoading, body, reloading, closing) => {
	setLoading(true);

	tk.punch.createPunch(body)
		.then(() => {
			closing();
			reloading();
		})
		.catch((error) => {
			console.error(error.message);
		})
		.finally(() => {
			setLoading(false);
		});
};

const disablePunches = async (
	setLoading,
	body,
	setDeleteRealPunches,
	reloading
) => {
	setLoading(true);

	await tk.punch.disablePunch(body)
		.then(() => {
			setDeleteRealPunches([]);
			reloading();
		})
		.catch((error) => {
			console.error(error.message);
		})
		.finally(() => {
			setLoading(false);
		});
};

const gettingTotals = async (
	setLoading,
	setRows,
	employee_id,
	start_date,
	end_date
) => {
	if (!employee_id || !start_date || !end_date) {
		setRows([]);
		setLoading(false);
		return;
	}

	setLoading(true);

	await tk.totalize.getTotalize({ employee_id, start_date, end_date })
		.then((response) => {
			const employeeTotals = response?.data?.[employee_id] || {};
			const days = Object.keys(employeeTotals);
			let results = [];

			for (let day of days) {
				for (let result of employeeTotals?.[day] || []) {
					if (!result?.paycode?.name) {
						continue;
					}

					results.push(result);
				}
			}

			const reduce = results.reduce((acc, result) => {
				if (result?.paycode?.name in acc) {
					const parts = result.amount.split(":");

					const amount = moment
						.duration({
							hours: parts[0],
							minutes: parts[1],
							seconds: parts[2],
						})
						.add(acc[result.paycode.name]?.amount);

					acc[result.paycode.name] = {
						id: result.paycode.name,
						paycode_id: result.paycode_id,
						paycode: result.paycode.name,
						amount,
					};
				} else {
					const parts = result.amount.split(":");

					const amount = moment.duration({
						hours: parts[0],
						minutes: parts[1],
						seconds: parts[2],
					});

					acc[result.paycode.name] = {
						id: result.paycode.name,
						paycode_id: result.paycode_id,
						paycode: result.paycode.name,
						amount,
					};
				}

				return acc;
			}, {});

			const rows = Object.keys(reduce).map((paycode) => ({
				id: paycode,
				paycode_id: reduce[paycode].paycode_id,
				amount: `${String(
					Math.floor(reduce[paycode].amount.asHours())
				).padStart(2, "0")}:${String(
					reduce[paycode].amount.minutes()
				).padStart(2, "0")}`,
				paycode: paycode,
			}));

			console.log("gettingTotals rows:", rows);

			setRows(rows);
		})
		.catch((error) => {
			console.error(error.message);
		})
		.finally(() => {
			setLoading(false);
		});
};

const gettingAllPaycodes = async (setLoading, setPaycodes) => {
	setLoading(true);
	tk.paycodes.getPaycodes("duration")
		.then((response) => {
			setPaycodes(response);
		})
		.catch((error) => {
			console.error(error);
		})
		.finally(() => {
			setLoading(false);
		});
};

const justifyException = async (setLoading, body, closing, reloading) => {
	setLoading(true);
	await tk.paycodes.savePaycodeAssignEmployees(body)
		.then((response) => {
			closing();
			reloading();
		})
		.catch((error) => {
			console.log(error.message);
		})
		.finally(() => {
			setLoading(false);
		});
};

const gettingShiftStatus = (t, params, apiRef, cacheRange1) => {
	const now = moment(new Date());

	if (now.isBetween(cacheRange1[0], cacheRange1[1])) {
		const row_id = params?.rowNode?.children?.find(
			(id) => id.slice(-10) === now.format("YYYY-MM-DD")
		);
		const row = apiRef.current.getRow(
			apiRef.current.getAllRowIds().find((id) => id === row_id)
		);

		if (row === null) {
			return t("timecard.table.cells.interpreting");
		}

		const shift = row?.shifts?.find((shift) =>
			now.isBetween(
				moment(`${shift.date} ${shift.start}`, "YYYY-MM-DD HH:mm"),
				moment(`${shift.date} ${shift.end}`, "YYYY-MM-DD HH:mm")
			)
		);

		const in_punches = row?.punch_in || [];
		const pairs = [];

		for (let punch of in_punches) {
			const last = pairs[pairs.length - 1];

			if (pairs.length > 0 && last.out === undefined) {
				last.out = punch.time;
			}

			const pair = {
				date: punch.date,
				in: punch.date_time, // undefined o la hora de entrada
				out: row?.punch_out?.find(
					(p) => p.total_span_index === punch.total_span_index
				)?.date_time,
				total_span_index: punch.total_span_index,
				exception: punch.exception,
			};

			pairs.push(pair);
		}

		if (row?.shifts?.length > 0) {
			// tengo un turno activo
			if (shift) {
				// 1-) Trabajando
				// 2-) Ausente
				// 3-) Trabajando con excepción
				// 4-) Turno finalizado con excepción

				const pairs_overlap = pairs
					.map((pair) => ({ ...pair }))
					.filter((pair) => {
						return (
							moment(
								`${shift.date} ${shift.start}`,
								"YYYY-MM-DD HH:mm"
							).isBefore(
								moment(
									pair.out ? pair.out : `${pair.date} 23:59`,
									"YYYY-MM-DD HH:mm"
								)
							) &&
							moment(
								pair.in ? pair.in : `${pair.date} 00:00`,
								"YYYY-MM-DD HH:mm"
							).isBefore(
								moment(
									`${shift.date} ${shift.end}`,
									"YYYY-MM-DD HH:mm"
								)
							)
						);
					});

				if (pairs_overlap.length > 0) {
					if (
						pairs_overlap.filter((pair) => pair.exception === true)
							.length > 0
					) {
						if (
							pairs_overlap.filter(
								(pair) => pair.out === undefined
							).length > 0
						) {
							return t(
								"timecard.table.cells.working_with_some_exceptions"
							);
						} else {
							return t(
								"timecard.table.cells.shift_ended_with_exceptions"
							);
						}
					} else {
						if (
							pairs_overlap.filter(
								(pair) => pair.out === undefined
							).length > 0
						) {
							return t("timecard.table.cells.working");
						} else {
							return t("timecard.table.cells.shift_ended");
						}
					}
				} else {
					return t("timecard.table.cells.absent");
				}
			} else {
				// 1-) Turno finalizado
				// 2-) Turno sin comenzar

				if (
					row?.shifts?.filter((shift) =>
						now.isBefore(
							moment(
								`${shift.date} ${shift.start}`,
								"YYYY-MM-DD HH:mm"
							)
						)
					).length > 0
				) {
					return t("timecard.table.cells.waiting_shift");
				}

				if (
					row?.shifts?.filter((shift) =>
						now.isAfter(
							moment(
								`${shift.date} ${shift.end}`,
								"YYYY-MM-DD HH:mm"
							)
						)
					).length > 0
				) {
					return t("timecard.table.cells.shift_ended");
				}
			}
		} else {
			if (pairs.length > 0) {
				const last_pair = pairs[pairs.length - 1];

				if (last_pair.out) {
					return t(
						"timecard.table.cells.shift_ended_without_schedule"
					);
				} else {
					return t("timecard.table.cells.working_without_schedule");
				}
			} else {
				return t("timecard.table.cells.free_day");
			}
		}
	} else {
		if (now.isBefore(cacheRange1[0])) {
			return t("timecard.table.cells.waiting_shift");
		}

		if (now.isAfter(cacheRange1[1])) {
			// 1-) Turno finalizado
			// 2-) Turno finalizado con excepciones
			// 3-) Ausente
			// 4-) Libre
			return t("timecard.table.cells.shift_ended");
		}
	}
};

const gettingTotalOvertime = (params, apiRef) => {
	const rows = params?.rowNode?.children
		? params?.rowNode?.children.map((id) => apiRef.current.getRow(id))
		: [];

	const totals = rows.reduce((acc, row) => {
		const time = row?.overtime.pending_overtime.amount.split(":");

		const hours = parseInt(time[0]);
		const minutes = parseInt(time[1]);

		const duration = moment.duration({ hours, minutes });

		return acc.add(duration);
	}, moment.duration(0));

	return `${Math.floor(totals.asHours())}:${totals
		.minutes()
		.toString()
		.padStart(2, "0")}`;
};

const gettingTotalWorkedHours = (params, apiRef) => {
	const rows = params?.rowNode?.children
		? params?.rowNode?.children.map((id) => apiRef.current.getRow(id))
		: [];

	const totals = rows.reduce((acc, row) => {
		const time = row?.worked_hours.split(":");

		const hours = parseInt(time[0]);
		const minutes = parseInt(time[1]);

		const duration = moment.duration({ hours, minutes });

		return acc.add(duration);
	}, moment.duration(0));

	return `${Math.floor(totals.asHours())}:${totals
		.minutes()
		.toString()
		.padStart(2, "0")}`;
};

const scheduleService = new ScheduleService();

const gettingSchedule = async (setLoading, setRows, employees, range) => {
	setLoading(true);
	await scheduleService.schedule.getSchedules(
		employees.map((employee) => employee.id),
		range[0].format("YYYY-MM-DD"),
		range[1].format("YYYY-MM-DD")
	)
		.then((response) => {
			setRows((prev) => {
				let replica = prev.map((row) => ({
					...row,
					shifts: response
						.filter(
							(shift) =>
								shift.employee_id === row.employee_id &&
								shift.date === row.date
						)
						.map((shift) => ({
							...shift,
							person_number: shift.employee_id,
							date: shift.date,
							start: moment(shift.start_ts, "HH:mm:ss").format(
								"HH:mm"
							),
							end: moment(shift.end_ts, "HH:mm:ss").format(
								"HH:mm"
							),
						})),
				}));

				return replica;
			});
		})
		.catch((error) => {
			console.error(error.message);
		})
		.finally(() => {
			setLoading(false);
		});
};

const gettingPunchesAndExceptions = async (
	setLoading,
	employee,
	range,
	setRows
) => {
	const employeeId = Array.isArray(employee)
		? employee[0]?.id
		: employee?.id;

	if (
		!employeeId ||
		!range?.[0] ||
		!range?.[1] ||
		!range[0].isValid() ||
		!range[1].isValid()
	) {
		setRows((prev) =>
			prev.map((row) => ({
				...row,
				punch_in: [],
				punch_out: [],
				exceptions: [],
			}))
		);
		setLoading(false);
		return;
	}

	setLoading(true);
	await tk.punch_match.getPunchMatch({
		employee_id: employeeId,
		start_date: range[0].format("YYYY-MM-DD"),
		end_date: range[1].format("YYYY-MM-DD")
	})
		.then((response) => {
			let punch_in = [];
			let punch_out = [];
			let exceptions = [];
			const punches = Array.isArray(response) ? response : [];

			for (let punch of punches) {
				let date = moment(
					punch.in_punch_real_time,
					"YYYY-MM-DDTHH:mm:ssZ"
				).isValid()
					? moment(
						punch.in_punch_real_time,
						"YYYY-MM-DDTHH:mm:ssZ"
					).format("YYYY-MM-DD")
					: moment(
						punch.out_punch_real_time,
						"YYYY-MM-DDTHH:mm:ssZ"
					).format("YYYY-MM-DD");

				punch_in.push({
					id: punch.in_punch,
					total_span_index: punch.punch_match_id,
					type: "in",
					date,
					time: moment(
						punch.in_punch_real_time
						//"YYYY-MM-DDTHH:mm:ssZ"
					).format("HH:mm"),
					date_time: moment(
						punch.in_punch_real_time
						//"YYYY-MM-DDTHH:mm:ssZ"
					).format("YYYY-MM-DD HH:mm"),
					missing: punch.in_punch_real_time === null ? true : false,
					exception:
						punch.start_reason === "Entrada planificada"
							? false
							: true,
					hover: false,
					real: true,
				});

				if (punch.start_reason !== "Entrada planificada") {
					exceptions.push({
						total_span_index: punch.punch_match_id,
						type: punch.start_reason,
						in_punch_flag: true,
						hover: false,
						date,
					});
				}

				punch_out.push({
					id: punch.out_punch,
					total_span_index: punch.punch_match_id,
					type: "out",
					date,
					time: moment(
						punch.out_punch_real_time
						//"YYYY-MM-DDTHH:mm:ssZ"
					)?.format("HH:mm"),
					date_time: moment(
						punch.out_punch_real_time
						//"YYYY-MM-DDTHH:mm:ssZ"
					)?.format("YYYY-MM-DD HH:mm"),
					missing: punch.out_punch_real_time === null ? true : false,
					exception:
						punch.end_reason === "Salida planificada"
							? false
							: true,
					hover: false,
					real: true,
				});

				if (punch.end_reason !== "Salida planificada") {
					exceptions.push({
						total_span_index: punch.punch_match_id,
						type: punch.end_reason,
						in_punch_flag: false,
						hover: false,
						date,
					});
				}
			}

			setRows((prev) => {
				let replica = prev.map((row) => ({
					...row,
					punch_in: punch_in.filter(
						(punch) => punch.date === row.date
					),
					punch_out: punch_out.filter(
						(punch) => punch.date === row.date
					),
					exceptions: exceptions.filter(
						(exception) => exception.date === row.date
					),
				}));

				console.log("1-) replica", replica);

				return replica;
			});
		})
		.catch((error) => {
			console.error(error.message);
		})
		.finally(() => {
			setLoading(false);
		});
};

const gettingAssingedPaycodes = async (
	setLoading,
	employee,
	range,
	setRows
) => {
	setLoading(true);

	const employeeId = Array.isArray(employee)
		? employee[0]?.id
		: employee?.id;

	if (
		!employeeId ||
		!range?.[0] ||
		!range?.[1] ||
		!range[0].isValid() ||
		!range[1].isValid()
	) {
		setRows((prev) =>
			prev.map((row) => ({
				...row,
				paycodes: [],
			}))
		);
		setLoading(false);
		return;
	}

	const params = new URLSearchParams();
	params.append("date_gte", range[0].format("YYYY-MM-DD"));
	params.append("date_lte", range[1].format("YYYY-MM-DD"));
	params.append("id_employee__in", employeeId);

	await tk.paycodes.getPaycodeAssignEmployee(params)
		.then((response) => {
			const assigned = Array.isArray(response) ? response : [];

			setRows((prev) => {
				let replica = prev.map((row) => ({
					...row,
					paycodes: assigned
						.filter((paycode) => paycode.date === row.date)
						.map((paycode) => ({
							paycode: paycode.paycode.name,
							date: paycode.date,
							amount: paycode.amount,
							type:
								paycode.paycode.unit === "hours"
									? "PCH"
									: "PCD",
							color:
								paycode.paycode.unit === "hours"
									? "secondary"
									: "primary",
						})),
				}));

				console.log("2-) replica", replica);

				return replica;
			});
		})
		.catch((error) => {
			console.error(error.message);
		})
		.finally(() => {
			setLoading(false);
		});
};

const gettingAssingedPaycodesInTotals = async (
	setLoading,
	employee,
	range,
	setRows
) => {
	setLoading(true);

	const employeeId = Array.isArray(employee)
		? employee[0]?.id
		: employee?.id;

	if (
		!employeeId ||
		!range?.[0] ||
		!range?.[1] ||
		!range[0].isValid() ||
		!range[1].isValid()
	) {
		setRows([]);
		setLoading(false);
		return;
	}

	const params = new URLSearchParams();
	params.append("date_gte", range[0].format("YYYY-MM-DD"));
	params.append("date_lte", range[1].format("YYYY-MM-DD"));
	params.append("id_employee__in", employeeId);
	await tk.paycodes.getPaycodeAssignEmployee(params)
		.then((response) => {
			let rows = [];
			const assigned = Array.isArray(response) ? response : [];

			for (let paycode of assigned) {
				const hours = Math.floor(paycode.amount);
				const minutes = Math.round((paycode.amount - hours) * 60);

				if (
					moment(paycode.date, "YYYY-MM-DD").isBetween(
						range[0],
						range[1],
						null,
						"[]"
					)
				) {
					rows.push({
						id: paycode.paycode.paycode_id,
						paycode_id: paycode.paycode.paycode_id,
						amount: `${hours.toString().padStart(2, "O")}:${minutes
							.toString()
							.padStart(2, "0")}`,
						paycode: paycode.paycode.name,
					});
				}
			}

			console.log("gettingAssingedPaycodesInTotals rows:", rows);

			setRows(rows);
		})
		.catch((error) => console.error(error.message))
		.finally(() => {
			setLoading(false);
		});
};
const totalizarService = new TotalizarService();
const gettingSimulatePunches = async (
	setLoading,
	body,
	setRows,
	setVirtualization,
	setVirtualTotals
) => {
	setLoading(true);

	if (body.punches.length === 0) {
		setLoading(false);

		setRows((prev) => {
			let replica = prev.map((row) => ({
				...row,
				punch_in: [],
				punch_out: [],
				exceptions: [],
			}));

			return replica;
		});

		setVirtualization(true);
		setVirtualTotals([]);

		return;
	}
	await totalizarService.totalizar.Totalize(body)
		.then((response) => {
			const punch_in = [];
			const punch_out = [];
			const exceptions = [];

			for (let result of response) {
				let date_in = moment(
					result?.punchMatch?.in_punch?.datetime,
					"YYYYY-MM-DDTHH:mm:ssZ"
				);

				if (!date_in.isValid()) {
					date_in = moment(
						result?.punchMatch?.out_punch?.datetime,
						"YYYYY-MM-DDTHH:mm:ssZ"
					);
				}

				const punch_in_id =
					result?.punchMatch?.in_punch !== null
						? result?.punchMatch?.in_punch?.id
						: getNegativeId();

				punch_in.push({
					id: punch_in_id,
					total_span_index: result?.punchMatch?.id,
					type: "in",
					date: date_in.format("YYYY-MM-DD"),
					time: moment(result?.punchMatch?.in_punch?.datetime).format(
						"HH:mm"
					),
					date_time: `${date_in.format("YYYY-MM-DD")} ${moment(
						result?.punchMatch?.in_punch?.datetime
					).format("HH:mm")}`,
					missing:
						result?.punchMatch?.in_punch === null ? true : false,
					exception:
						result?.punchMatch?.start_reason ===
							"Entrada planificada"
							? false
							: true,
					hover: false,
					real: true,
				});

				if (
					result?.punchMatch?.start_reason !== "Entrada planificada"
				) {
					exceptions.push({
						total_span_index: result?.punchMatch?.id,
						type: result?.punchMatch?.start_reason,
						in_punch_flag: true,
						hover: false,
						date: date_in.format("YYYY-MM-DD"),
					});
				}

				let date_out = moment(
					result?.punchMatch?.out_punch?.datetime,
					"YYYYY-MM-DDTHH:mm:ssZ"
				);

				if (!date_out.isValid()) {
					date_out = moment(
						result?.punchMatch?.in_punch?.datetime,
						"YYYYY-MM-DDTHH:mm:ssZ"
					);
				}

				const punch_out_id =
					result?.punchMatch?.out_punch !== null
						? result?.punchMatch?.out_punch?.id
						: getNegativeId();

				punch_out.push({
					id: punch_out_id,
					total_span_index: result?.punchMatch?.id,
					type: "out",
					date: date_out.format("YYYY-MM-DD"),
					time: moment(
						result?.punchMatch?.out_punch?.datetime
					).format("HH:mm"),
					date_time: `${date_out.format("YYYY-MM-DD")} ${moment(
						result?.punchMatch?.out_punch?.datetime
					).format("HH:mm")}`,
					missing:
						result?.punchMatch?.out_punch === null ? true : false,
					exception:
						result?.punchMatch?.end_reason === "Salida planificada"
							? false
							: true,
					hover: false,
					real: true,
				});

				if (result?.punchMatch?.end_reason !== "Salida planificada") {
					exceptions.push({
						total_span_index: result?.punchMatch?.id,
						type: result?.punchMatch?.end_reason,
						in_punch_flag: false,
						hover: false,
						date: date_out.format("YYYY-MM-DD"),
					});
				}
			}

			console.log("punch_in", punch_in);
			console.log("punch_out", punch_out);
			console.log("exceptions", exceptions);

			setRows((prev) => {
				let replica = prev.map((row) => ({
					...row,
					punch_in: punch_in.filter(
						(punch) => punch.date === row.date
					),
					punch_out: punch_out.filter(
						(punch) => punch.date === row.date
					),
					exceptions: exceptions.filter(
						(exception) => exception.date === row.date
					),
				}));

				console.log("replica", replica);

				return replica;
			});

			setVirtualization(true);

			let virtualTotals = [];

			for (let result of response) {
				if (result?.resultTotalizeByDay.length > 0) {
					for (let resultTotalizes of result?.resultTotalizeByDay) {
						virtualTotals.push({
							id: 0,
							amount: resultTotalizes?.day?.quantity_worked,
							paycode: "quantity worked",
							paycode_id: 0,
						});

						for (let totalize of resultTotalizes?.totalizes) {
							virtualTotals.push({
								id: totalize.paycode_id,
								amount: totalize.amount,
								paycode: totalize.paycode_name,
								paycode_id: totalize.paycode_id,
							});
						}
					}
				}
			}

			console.log("virtualTotals", virtualTotals);

			setVirtualTotals(virtualTotals);
		})
		.catch((error) => {
			console.error("simulatePunch", error.message);
		})
		.finally(() => {
			setLoading(false);
		});
};

export {

	createPunch,
	gettingTotals,


	gettingAllPaycodes,
	justifyException,




	gettingShiftStatus,
	gettingTotalOvertime,
	gettingTotalWorkedHours,
	gettingSchedule,
	gettingPunchesAndExceptions,
	gettingAssingedPaycodes,
	gettingAssingedPaycodesInTotals,
	gettingSimulatePunches,
	disablePunches,
};
